

import router from "@/router/index.js"
import { useAuthStore } from '@/stores/auth.js'
import { request } from '@/utils/fetch.js'
import { showNotify } from '@/utils/show.js'


const baseURL = import.meta.env.VITE_API_BASE_URL
// 刷新状态和失败请求队列
let isRefreshing = false
let failedRequests = []

export async function rp(url, { throwError, ...options } = {}) {
  const { accessToken } = useAuthStore()
  const config = {
    baseURL, ...options,
    headers: {
      ...options.headers,
      Authorization: accessToken,
    },
  }
  const res = await request(url, config)

  if (res?.statusCode === 401 && !options._retry) {
    return handle401(url, config)
  }

  if (res?.code && throwError) throw res
  return res
}

export async function handle401(url, options = {}) {
  options._retry = true

  if (!isRefreshing) refreshRetry()

  return new Promise((resolve, reject) => {
    failedRequests.push({ resolve, reject })
    // console.log('handle401 push:', url,)
  })
    .then(() => {
      // console.log('handle401 resolve:', url,)
      return rp(url, options)
    })
    .catch((err) => Promise.reject(err))
}

export async function getTokenByRefreshToken() {
  const { refreshToken, saveAuth } = useAuthStore()
  if (!refreshToken) throw new Error('没有refreshToken, 请重新登录')

  const res = await request(`/v1/token/refresh?refreshToken=${refreshToken}`, { baseURL, method: 'GET' })
  if (res?.accessToken) {
    // const { accessToken, refreshToken } = res
    saveAuth(res)
    return res
  }
  throw new Error(`${res.code}:${res.message}`)
}

async function refreshRetry() {
  isRefreshing = true
  // console.log('Before refresh:', failedRequests.length, new Error().stack) // 检查调用栈
  try {
    await getTokenByRefreshToken()
    setTimeout(() => {
      // console.log('failedRequests len:', failedRequests.length)
      // failedRequests.forEach(({ resolve }) => resolve())
      while (failedRequests.length) failedRequests.shift().resolve()
      // console.log('isRefreshing false:')
      isRefreshing = false
    }, 300)
  } catch (err) {
    console.error('refreshRetry err:', err)
    showNotify(`${err?.message}, 请重新登录`, 'error')
    // failedRequests.forEach(({ reject }) => reject(err))

    setTimeout(() => {
      console.log('failedRequests err len:', failedRequests.length)
      while (failedRequests.length) failedRequests.shift().reject('toLogin')

      console.log('router:', router)
      if (router && router.currentRoute.value.path !== '/auth/signup') {
        // replace: true 会修改当前历史记录，而不是新增，用户无法通过“后退”返回上一个页面。
        // router.push({ name: "login", replace: true })
        router.push({ name: "login", replace: true })
        // router.push('/login')
      }
      isRefreshing = false
    }, 300)
  }
}

export function get(url, options = {}) {
  return rp(url, { method: 'GET', ...options })
}

export function post(url, data, options = {}) {
  return rp(url, { method: 'POST', data, ...options })
}

export function put(url, data, options = {}) {
  return rp(url, { method: 'PUT', data, ...options })
}

export const http = {
  get(url, options = {}) {
    return rp(url, { method: 'GET', ...options })
  },
  post(url, data, options = {}) {
    return rp(url, { method: 'POST', data, ...options })
  },
  put: (url, data, options = {}) => {
    return rp(url, { method: 'PUT', data, ...options })
  },
  delete: (url, options = {}) => {
    return rp(url, { method: 'DELETE', ...options })
  },
}